import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_PROGRESS_ENDPOINT: APP_PROGRESS_ENDPOINT,
  REACT_APP_SEND_PROGRESS_ENDPOINT: SEND_PROGRESS_ENDPOINT,
  REACT_APP_LATEST_UNSUBMITTED_APPLICATION_ENDPOINT: LATEST_UNSUBMITTED_APPLICATION_ENDPOINT,
} = process.env;

export const urlFor = (applicationId, customerGuid) =>
  `${ONBOARDING_API_HOST}${APP_PROGRESS_ENDPOINT}`
    .replace('{applicationId}', applicationId)
    .replace('{customerGuid}', customerGuid);

export const url = `${ONBOARDING_API_HOST}${SEND_PROGRESS_ENDPOINT}`;

export const urlForLatestUnsubmitedApplicationForUser = userGuid =>
  `${ONBOARDING_API_HOST}${LATEST_UNSUBMITTED_APPLICATION_ENDPOINT}`.replace(
    '{customerGuid}',
    userGuid,
  );

export default class ProgressAPI {
  static sendProgress = (params, token) => {
    return APIClient.post(url, params, token).then(response => response.data);
  };

  static fetchProgressFor = (applicationId, customerGuid, token) => {
    return APIClient.get(urlFor(applicationId, customerGuid), token).then(
      response => response.data,
    );
  };

  static fetchLatestUnsubmitedFor = (customerGuid, token) => {
    return APIClient.get(urlForLatestUnsubmitedApplicationForUser(customerGuid), token).then(
      response => response.data,
    );
  };
}
